import { Component, OnInit, HostListener, ViewChildren, QueryList, AfterContentInit, ViewChild, ContentChildren, AfterViewInit, Renderer2, ElementRef, Input, OnDestroy, Output, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { ButtonComponent, ButtonInfo } from '../button.component';
import { ButtonProxyComponent } from '../button-proxy/button-proxy.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ButtonGroupService } from 'src/app/services/button-group.service';
import { UUID } from 'angular2-uuid';

@Component({
  selector: 'app-button-set',
  templateUrl: './button-set.component.html',
  styleUrls: ['./button-set.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonSetComponent implements AfterViewInit, AfterContentInit, OnDestroy {
  @ContentChildren(ButtonComponent) buttons: QueryList<ButtonComponent>;
  @ViewChild('proxy') proxy: ButtonProxyComponent;
  @Output() positionUpdated = new EventEmitter<void>();
  private lookup: Array<ButtonComponent>;
  private selectedIndex = 0;
  private subscriptions = new SubScriptionMgr();
  private isDisabled = false;
  private isActiveOnly = false;
  public name: string = '';
  public groupName: string = '';
  @Input() set disabled(isDisabled: string) {
    this.isDisabled = isDisabled === 'true';
  }
  get disabled(): string {
    return this.isDisabled ? 'true' : 'false';
  }
  @Input() set showOnActivated(isAO: string) {
    this.isActiveOnly = isAO === 'true';
  }
  get showOnActivated(): string {
    return this.isActiveOnly ? 'true' : 'false';
  }
  @Input() set setName(name: string) {
    this.name = name.trim();
    this.groupName = name.trim();
    if (this.name !== '') {
      this.groups.RegisterButtonSet(name, this);
    }

  }
  private _isOn = false;
  @Input()
  set isOn(isOn: boolean) {
    this._isOn = isOn;
    if (!this.proxy) {
      window.requestAnimationFrame(() => {
        this.isOn = isOn;
      })
    }
    this.proxy.button.isOn = isOn;
  }
  get isOn() {
    return this._isOn;
  }
  private _dropdownTitle: string = '';
  @Input('dropdown-title')
  set dropdownTitle(title: string) {
    this._dropdownTitle = title;
    this.cdr.markForCheck();
    this.Refresh();
  }
  get dropdownTitle(): string {
    return this._dropdownTitle;
  }
  public id = '';
  private _ready = false;
  constructor(private renderer: Renderer2, private domNode: ElementRef, private groups: ButtonGroupService,
    private cdr: ChangeDetectorRef) {
    this.id = UUID.UUID();
  }
  /*@HostListener('click',['$event']) HandleClick(event:MouseEvent) {
  if(event.target.localName === 'app-button-proxy'
  console.log(event);
  }*/



  ngAfterContentInit(): void {
    this._ready = true;
    this.buttons.forEach((button: ButtonComponent, index: number) => {
      button.element.addEventListener('click', ($event) => { this.HandleButtonSelect(button); });
      button.isOnChange.subscribe((isOn: boolean) => {
        this.groups.CloseAll();

        if (this.isActiveOnly && isOn === true) {
          this.HandleButtonSelect(button);
        } else {
          if (button.id === this.proxy.buttonInfo.guiId) {
            this.HandleButtonSelect(button);
          }
        }

      })
    });
    this.Refresh();
  }
  ngAfterViewInit(): void {

    this.lookup = Array.from(this.buttons);
    this.lookup.every((button: ButtonComponent, index: number) => {
      if (index === 0) {
        this.HandleButtonSelect(button);
        this.selectedIndex = index;
      }
      this.subscriptions.Subscribe(button.change, (buttonInfo: ButtonInfo) => {
        if (this.proxy.guidId === buttonInfo.guiId) {
          this.proxy.set(buttonInfo);
        }
      });
      return true;
    });
    this.proxy.DropdownReady();
    this.subscriptions.Subscribe(this.proxy.click, (buttonInfo: ButtonInfo) => {
      this.lookup.every((button: ButtonComponent, _index: number) => {
        if (button.id === buttonInfo.guiId) {
          if (button.isToggleable) {
            button.Toggle(this.proxy.button.isOn, false);
          } else {
            button.Click();
          }
        }
        return true;
      });
    });
    this.Refresh();

  }
  HandleButtonSelect(button: ButtonComponent) {
    this.proxy.set(button.Clone());
    // this.proxy.dropdownTitle = this.dropdownTitle;
    this.Refresh();
  }
  HandleWheel(event: WheelEvent) {
    console.log(event.deltaY);
    event.preventDefault();
    if (event.deltaY > 0) {
      this.SelectPrev();
    } else {
      this.SelectNext();
    }
  }
  SelectNext() {
    this.selectedIndex += 1;
    if (this.selectedIndex >= this.lookup.length) {
      this.selectedIndex = 0;
    }
    this.HandleButtonSelect(this.lookup[this.selectedIndex]);
  }
  SelectPrev() {
    this.selectedIndex -= 1;
    if (this.selectedIndex < 0) {
      this.selectedIndex = this.lookup.length - 1;
    }
    this.HandleButtonSelect(this.lookup[this.selectedIndex]);
  }
  ngOnDestroy() {
    if (this.name !== '') {
      this.groups.UnRegisterButtonSet(this.name);
    }
  }
  Close() {
    this.proxy.Close();
    this.Refresh();
  }
  UpdatePosition() {
    this.proxy.Resized();
    this.Refresh();
    this.positionUpdated.emit();
  }
  Refresh() {
    if (!this._ready) return;
    if (this.cdr)
      this.cdr.detectChanges();
  }
  ToggleButton(name: string, isOn: boolean) {
    this.buttons.forEach((button) => {
      if (button.isOn !== isOn) {
        if (button.buttonName === name) button.Toggle(isOn);
      }
    });
  }
  ToggleButtons(buttonNames: Array<string>, isOn: boolean) {
    this.buttons.forEach((button) => {
      if (buttonNames.indexOf(button.buttonName) > -1) {
        if (button.isOn !== isOn) button.Toggle(isOn);
      }
    });
  }
}
